import React from 'react'
import styled from 'styled-components';


import { AuditEntry } from '../../model/AuditEntry';
import VersionHistoryComponent from './VersionHistoryComponent';


interface IProps {
    entries: AuditEntry[]
}

const Style = styled.div`

h2{
    margin-top: 3rem;
}


`;

const GenericHistoryComponent: React.FC<IProps> = (props: IProps) => {


    return <Style  >
    <h2>Version History</h2>
    { !props.entries.length && <p>No Version History</p>}
    { !!props.entries.length && props.entries.map((x,i)=><VersionHistoryComponent key={x.id} entry={x} versionNumber={props.entries.length - i} />)}
    </Style>
}

export default GenericHistoryComponent;